var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.type,{tag:"component"}),_c('script-modal'),_c('notes-modal'),_c('file-upload'),_c('approval-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }